module.exports = (__webpack_require__(24))(1);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/prop-types/index.js from dll-reference lib_core
// module id = 22
// module chunks = 105